<template>
	<div class="grid" v-if="getMovil() == null || getParada() == null || getEsMovil() == null || getEsMovil() == 0">
		<div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-2">
			<Message severity="error" class="p-col-12">
				Para poder operar en el sistema debe seleccionar el comedor y parada donde está cumpliendo funciones. La funcionalidad multplicador solo está habilitada para comedores no tradicionales.
			</Message>
		</div>
	</div>
    <div class="grid" v-if="getMovil() != null && getParada() != null && getEsMovil() == 1">
		<div class="col-12 md:col-6 xl:col-3">
			<div class="card grid-nogutter widget-overview-box widget-overview-box-1">
				<span class="overview-icon">
					<i class="pi pi-bolt"></i>
				</span>
				<span class="overview-title">Selección de factor multiplicador</span>
				<div class="grid overview-detail">
					<div class="col-12">
						<div class="overview-subtext">Seleccione el factor multiplicador para la entrega de viandas. Por defecto es x1 pero puede modificarlo por las otras opciones disponibles 
                            en caso de ser necesario.</div>
					</div>
				</div>
			</div>
		</div>

		<div class="grid p-mt-5">
			<div class="col-12">
				<div class="card">
                    <Toast/>
                    <div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-2">
                        <div class="p-field p-col-12 p-md-6">
                            <Fieldset legend="Datos del usuario">
                                <div class="p-grid p-mt-3">
                                    <div class="p-col-12 p-md-6">
                                        Nombre:
                                    </div>
                                    <div class="p-col-12 p-md-6">
                                        {{nombrepersona}}
                                    </div>
                                </div>
                                <div class="p-grid p-mt-3">
                                    <div class="p-col-12 p-md-6">
                                        Cédula de Identidad:
                                    </div>
                                    <div class="p-col-12 p-md-6">
                                        {{cipersona}}
                                    </div>
                                </div>
                            </Fieldset>
                        </div>
                        <div class="p-field p-col-12 p-md-6">
                            <div>
                                <label for="moviles">Factor multiplicador para la entrega de viandas</label>
                                <SelectButton v-model="multiplicador" :options="selectButtonValues" optionLabel="name" optionValue="value" class="p-mt-3"/>
                            </div>
                        </div>
                    </div>
                   
                    <Toolbar>
                        <template v-slot:left>
                            
                        </template>

                        <template v-slot:right>
                            <Button label="Elegir" @click="elegir()" icon="pi pi-angle-right" iconPos="left"/>
                        </template>
                    </Toolbar>
				</div> 
			</div>
		</div>   
	</div>	
    <Dialog header="Aguarde..." :visible="wait" :style="{width: '150px'}" :modal="true" :position="left">
        <div align="center">
            <ProgressSpinner style="width:50px;height:50px" strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"/>
        </div>
	</Dialog> 	
</template>

<script>
export default {
	data() {
		return {
            wait: false,
            nombrepersona: "",
			cipersona: "",
            multiplicador:null,
            selectButtonValues: [
					{name: 'sin multiplicar', value: 1},
					{name: 'x2', value: 2},
					{name: 'x3', value: 3},
			],
		}
	},	
	created() {
        
	},

	mounted() {
        this.cargarDatos();
	},

	methods: {
        
        getMovil(){
            return localStorage.movil_id;
        },

        getParada(){
            return localStorage.parada_id;
        },

        getEsMovil(){
            return localStorage.esMovil;
        },

        elegir(){
            this.variableGlobal();
        },

        async cargarDatos() {
			this.wait= true;
			if (localStorage.nombre){
				this.nombrepersona= localStorage.nombre;
				this.cipersona= localStorage.cedula;
                this.multiplicador = Number(localStorage.multiplicador);
			}
			this.wait= false;
		},

        variableGlobal() {
			localStorage.multiplicador = this.multiplicador;
            this.$toast.add({severity:'success', summary: 'Multiplicador seleccionado', detail:'Se eligió el factor multiplicador para la entrega de viandas.', life: 3000});
		},
	},
}
</script>

<style scoped lang="scss">
	.overview-detail {
        text-align: left;
        margin-top: 2rem;

        .p-col-6 {
            padding: .5rem;
        }
    }
</style>